import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { FacebookIcon, TwitterIcon, GPlusIcon, LinkIcon } from '../../components/icons';
import styles from './share-button.scss';

const ICONS = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  gPlus: GPlusIcon,
  link: LinkIcon,
};

class ShareButton extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onClick, type } = this.props;
    onClick(type);
  }

  render() {
    const { type, title } = this.props;
    const Icon = ICONS[type];
    return (
      <button
        className={classNames(styles.button, styles[type])}
        onClick={this.handleClick}
        aria-label={title}
        data-hook={`share-button__${type}`}
      >
        <Icon className={styles.icon}/>
      </button>
    );
  }
}

export default ShareButton;



// WEBPACK FOOTER //
// ./app/components/share-button/share-button.js